import { useEffect, useState } from "react";
import { Radar as RadarIcon, ExternalLink } from "lucide-react";

const BASE_WINDY =
  "https://embed.windy.com/embed2.html?lat=32.7&lon=-83.6&detailLat=32.7&detailLon=-83.6&width=650&height=450&zoom=6&level=surface&overlay=radar&product=radar&menu=&message=true&marker=&calendar=now&pressure=&type=map&location=coordinates&detail=&metricWind=mph&metricTemp=%C2%B0F&radarRange=-1";

export default function RadarSection() {
  // Windy uses WebGL which can degrade after many hours on a 24/7 kiosk.
  // Force a fresh reload every 20 min so the WebGL context never rots overnight.
  const [reloadKey, setReloadKey] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setReloadKey((k) => k + 1), 20 * 60 * 1000);
    return () => clearInterval(t);
  }, []);

  return (
    <section id="radar" className="relative py-14">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="mb-6 flex items-end justify-between">
          <div>
            <div className="font-oswald text-xs uppercase tracking-[0.3em] text-[#1f63c9]">Live Doppler</div>
            <h2 className="font-oswald text-2xl font-bold uppercase tracking-wider text-white sm:text-3xl lg:text-4xl">
              Georgia Interactive Radar
            </h2>
          </div>
          <a
            href="https://www.weather.gov/radar"
            target="_blank"
            rel="noreferrer"
            className="hidden items-center gap-1 font-mono text-xs uppercase tracking-widest text-gray-400 hover:text-white sm:flex"
          >
            NWS Source <ExternalLink className="h-3 w-3" />
          </a>
        </div>

        <div className="relative overflow-hidden rounded border border-white/10 bg-black">
          <div className="absolute left-3 top-3 z-10 flex items-center gap-2 rounded bg-black/70 px-2 py-1">
            <RadarIcon className="h-4 w-4 text-[#1f63c9]" />
            <span className="font-oswald text-[10px] font-bold uppercase tracking-widest text-white">Doppler Radar</span>
          </div>
          <div className="aspect-[16/10] w-full">
            <iframe
              key={reloadKey}
              title="Georgia Radar"
              src={`${BASE_WINDY}&_r=${reloadKey}`}
              frameBorder="0"
              className="h-full w-full"
              allow="fullscreen"
              sandbox="allow-scripts allow-same-origin allow-popups"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
